import styled from '@emotion/styled';
import { Table } from 'antd';

export const UsersTable = styled(Table)`
  margin-top: ${props => props.theme.spacing.md};
`;
